import React from "react";
import Hero from "../components/Hero";

// Importamos las imágenes desde la carpeta assets
// Ajusta los nombres según tus archivos.
import vinosImg from "../assets/vinos.jpg";
import comidaImg from "../assets/comida.jpg";
import cursosImg from "../assets/cursos.jpg";
import personalImg from "../assets/personal.jpg";

function Home() {
  return (
    <div>
      <Hero
        title="Qdamos"
        subtitle="Un lugar elegante y sofisticado para disfrutar."
      />
      <section className="content-section">
        <h2>La Experiencia Qdamos</h2>
        <p>
          {/* Puedes dejar este texto o agregar información adicional */}
          Disfruta de nuestros productos y servicios de la más alta calidad.
        </p>

        {/* Bloque 1: Imagen izquierda, Texto derecha */}
        <div className="row">
          <img src={vinosImg} alt="Vinos" />
          <div className="text-container">
            <h3>Vinos</h3>
            <p>
              Nuestra cuidada selección de vinos te permitirá vivir una
              experiencia enológica inigualable.
            </p>
          </div>
        </div>

        {/* Bloque 2: Imagen derecha, Texto izquierda */}
        <div className="row reverse">
          <img src={comidaImg} alt="Comida" />
          <div className="text-container">
            <h3>Comida</h3>
            <p>
              Degusta nuestros platillos cuidadosamente elaborados por chefs
              expertos, con ingredientes frescos y de alta calidad.
            </p>
          </div>
        </div>

        {/* Bloque 3: Imagen izquierda, Texto derecha */}
        <div className="row">
          <img src={cursosImg} alt="Cursos" />
          <div className="text-container">
            <h3>Cursos</h3>
            <p>
              Participa en nuestros cursos y talleres gastronómicos, enológicos
              y más, impartidos por profesionales reconocidos.
            </p>
          </div>
        </div>

        {/* Bloque 4: Imagen derecha, Texto izquierda */}
        <div className="row reverse">
          <img src={personalImg} alt="Personal" />
          <div className="text-container">
            <h3>Personal</h3>
            <p>
              Conoce al equipo que hace posible Qdamos: apasionados, creativos y
              dedicados a ofrecerte la mejor experiencia.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
